<template>
  <div class="visibility-flags">
    <div v-if="project.isPrivate" class="private" data-balloon="Private" data-balloon-pos="left"><i class="fal fa-lock" aria-hidden="true"></i></div>
    <div v-if="project.isDraft" class="draft" data-balloon="Draft" data-balloon-pos="left"><i class="fal fa-pencil" aria-hidden="true"></i></div>
    <div v-if="project.isHidden && isAdmin" class="hidden" data-balloon="Hidden" data-balloon-pos="left"><i class="fal fa-eye-slash" aria-hidden="true"></i></div>
  </div>

</template>

<script>

import auth from '@/mixins/auth'

export default {
  props: ['project', 'across'],
  mixins: [auth]
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.visibility-flags {
  position: absolute;
  top: 44%;
  right: 5%;
  z-index: 4;
  @include tablet-only  {
    top: 49%;
  }
  @include mobile {
    top: 53%;
  }
  .private, .draft, .hidden {
    font-size: 0.7rem;
    background: #333;
    color: white;
    opacity: 0.75;
    padding: 0.12rem 0.4rem;
    margin-bottom: 0.2rem;
    border-radius: 5px;
    text-align: center;
  }
}

</style>
